import { Loader2 } from "lucide-react";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#101D51] tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-[#6B7189] mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Loading({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-20 text-[#6B7189]">
      <Loader2 className="w-5 h-5 animate-spin mr-2" /> {label}
    </div>
  );
}

export function Empty({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {Icon && <div className="w-14 h-14 rounded-2xl bg-[#F5F6FA] flex items-center justify-center mb-3">
        <Icon className="w-7 h-7 text-[#6B7189]" /></div>}
      <div className="font-semibold text-[#101D51]">{title}</div>
      {hint && <div className="text-sm text-[#6B7189] mt-1 max-w-sm">{hint}</div>}
    </div>
  );
}

const CARD = "border border-[#E6E8F0] rounded-xl shadow-sm bg-white";
export function Card({ className = "", children, ...p }) {
  return <div className={`${CARD} ${className}`} {...p}>{children}</div>;
}
